import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "tag-container q-d-flex q-justify-content-center q-flex-wrap" }
const _hoisted_2 = ["data-field", "value", "onClick"]
const _hoisted_3 = { class: "q-tag-list__tooltip" }

import {storeToRefs} from 'pinia'
import {useFiltersStore} from '@/store/SerpPage/FiltersStore'
import {onMounted, inject, toRefs} from 'vue'

import {SmartSearchConfigInterface} from '@/core/types'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'TagList',
  setup(__props) {

const filtersStore = useFiltersStore()
const {getFiltersToTagList} = storeToRefs(filtersStore)

const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')
const {showAsideFilters} = toRefs(SmartSearchConfig.value.serp.filters)

onMounted(() => {
  if (!showAsideFilters.value) {
    filtersStore.fetchFilters()
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFiltersToTagList), (values, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: "q-tag-item__button q-btn q-btn-sm q-bg-white q-m-1 q-py-1 q-rounded-3 q-shadow-sm",
        "data-field": values.field,
        value: values.label,
        onClick: ($event: any) => (_unref(filtersStore).updateFilter(values.field, values.value.label))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(values.label), 1),
        _createTextVNode(" " + _toDisplayString(values.value.label), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})